// extracted by mini-css-extract-plugin
export default {"application_form":"ApplicationForm_application_form__A71qj","heading":"ApplicationForm_heading__C9+aU","application_btns":"ApplicationForm_application_btns__8zBMr"};